import BaseStore from 'customer-flows/stores/base-store'

export default class RentalAvailabilityStoreClass extends BaseStore {
  /**
   * For rentals, each availability entry is a distinct physical resource — summing is correct.
   */
  getMaxSpotsLeftForSlot(slot: AvailabilityTime): number {
    return slot.availability.reduce((sum, a) => sum + a.qty, 0)
  }
}

declare global {
  export type RentalAvailabilityStore = RentalAvailabilityStoreClass
  export interface StoreRegistry {
    'availability/rental': RentalAvailabilityStore
  }
}
